import { setUsername, setName, setToken, setIsLogin, setInitialState, setRole, setProfilePicure } from "../actions/ActionTypes"

export interface initialUserStateInterface {
  username: string,
  name: string,
  role: string,
  profilePicture: string,
  token: string,
  isLogin: boolean,
}

const initialState : initialUserStateInterface = { 
  username: '',
  name: '',
  role: '',
  profilePicture: '',
  token: '',
  isLogin: false,
}

function userReducer (state = initialState , action: {type:string, payload:any}) {
  switch (action.type) { 
    case setUsername : 
      return { ...state , username : action.payload}
    
    case setName : 
      return { ...state , name : action.payload}

    case setRole : 
      return { ...state , role : action.payload}

    case setProfilePicure : 
      return { ...state , profilePicture : action.payload}

    case setToken : 
      return { ...state , token : action.payload}

    case setIsLogin :  
      return { ...state , isLogin : action.payload}

    case setInitialState : 
      return { isLogin : false , token : '' , username : '' , name:'' , role:'', profilePicture:''}

    default :
      return state
  }
}

export default userReducer;